import restAPI from "../http-common";
import session from "./session";

class HelpApi {
	/**
	 * Sends a support email.
	 *
	 * @param      {string}  subject  The subject
	 * @param      {string}  text     The text of the email
	 */
	sendSupportEmail(subject, text) {
		return restAPI({
			method: "post",
			url: "/send-support-email",
			data: {
				subject,
				text,
			},
			headers: session.getIdToken() ? { Authorization: session.getIdToken() } : {},
		});
	}
}

export const HelpService = new HelpApi();
